import React, { useState, useEffect } from 'react'
import { APISERVICE, setToken } from '../services/api.service'
import { useDispatch } from 'react-redux'
import '../styles/Login.css'
import { Button, Spinner } from 'react-bootstrap'
import { FcGoogle } from 'react-icons/fc'
import { clearTeacher, updateTeacherInfo } from '../redux/states/docente'
import { useGoogleLogin } from '@react-oauth/google'
import { toast } from 'react-toastify'
import { setLoginData } from 'redux/states/authSlice'
import { useNavigate } from 'react-router-dom'
import { PrivateRoutes } from 'routes/rutas'
import { userKey } from 'data/constants'

export const clearLocalStorage = (key) => {
    localStorage.removeItem(key)
}
function Login() {
    const navigate = useNavigate()
    const [user, setFormData] = useState({
        username: '',
        password: '',
    })
    const [error, setError] = useState('')
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [loadingGoogle, setLoadingGoogle] = useState(false)

    const handleInputChange = (event) => {
        const { name, value } = event.target
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        try {
            setError('')
            setLoading(true)
            let url = 'usuario/login'
            const response = await APISERVICE.post(url, '', user)
            if (response.success) {
                if (response.auth.roles.includes('docente')) {
                    accessAsTeacher(response)
                } else {
                    accessAsUser(response)
                }
            } else {
                setError(<p style={{ textAlign: 'center', color: 'red' }}>*Error de Usuario o Contraseña </p>)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        clearLocalStorage(userKey)
        dispatch(clearTeacher())
    }, [])

    const accessAsUser = (data) => {
        const { auth: { accessToken } } = data
        setToken(accessToken)
        dispatch(setLoginData(accessToken))
        navigate(PrivateRoutes.ROOT)
    }
    const accessAsTeacher = (data) => {
        const {
            auth: { roles, accessToken },
            user: { id, username, nombre, teacherId },
        } = data
        setToken(accessToken)
        dispatch(setLoginData(accessToken))
        let infoTeacher = {
            username,
            rol: roles,
            access_token: accessToken,
            teacherInfo: {
                access_token: accessToken,
                rol: roles.reduce((carry, r) => {
                    carry[r] = true
                    return carry
                }, {}),
                nombre,
                id,
                teacherId,
            },
        }
        dispatch(updateTeacherInfo(infoTeacher))
        navigate(PrivateRoutes.ROOT)
    }

    const loginGoogle = useGoogleLogin({
        onSuccess: (codeResponse) => {
            loginTeacher(codeResponse.access_token)
        },
        onError: (error) => console.log('Login Failed:', error),
    })

    const loginTeacher = async (access_token) => {
        try {
            setLoadingGoogle(true)
            const url = 'usuario/login'
            const response = await APISERVICE.post(url, '', { access_token })
            if (response.success) {
                accessAsTeacher(response)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
        } finally {
            setLoadingGoogle(false)
        }
    }

    return (
        <>
            <section className='conteiner-login d-flex flex-column'>
                <header className='mb-5'>
                    <h1 className='title fst-italic'>Bienvenido a PST</h1>
                </header>

                <main className='formulario'>
                    <form onSubmit={handleSubmit}>
                        <div className='w-100 mb-4'>
                            <label className='form-label' htmlFor='username'>
                                Usuario
                            </label>
                            <input
                                type='text'
                                className='formulario-input w-100'
                                id='username'
                                name='username'
                                value={user.username}
                                onChange={handleInputChange}
                                placeholder='Ingrese su nombre de usuario'
                                autoComplete='off'
                                required
                            />
                        </div>
                        <div className='w-100 mb-5'>
                            <label className='form-label' htmlFor='password'>
                                Contraseña
                            </label>
                            <input
                                type='password'
                                className='formulario-input w-100'
                                id='password'
                                name='password'
                                value={user.password}
                                onChange={handleInputChange}
                                placeholder='Ingrese su contraseña'
                                required
                            />
                        </div>
                        {error}
                        <div className='text-center'>
                            <Button type='submit' variant='blue' className='btn-login'>
                                {loading ? <Spinner variant='light' size='sm' /> : 'Iniciar sesión'}
                            </Button>
                        </div>
                    </form>
                    {false && (
                        <>
                            <div className='text-center py-2'>o</div>
                            <div className='btn-login content-btnlogin' onClick={() => loginGoogle()}>
                                <FcGoogle />
                                <div className='content-btnlogin__text'>
                                    {loadingGoogle ? <button>Cargando...</button> : <button>Ingresar con Google</button>}
                                </div>
                            </div>
                        </>
                    )}
                </main>
            </section>
        </>
    )
}

export default Login
